/**
 *
 * @param {String} string String to convert to slug
 * @returns {string|*}
 */
export default function slugify(string) {
  let str = string.replace(/^\s+|\s+$/g, '').toLowerCase();

  const from = 'àáäâãèéëêìíïîõòóöôùúüûñç·/_,:;';
  const to = 'aaaaaeeeeiiiiooooouuuunc------';

  for (let i = 0, l = from.length; i < l; i += 1) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '')
           .replace(/\s+/g, '-')
           .replace(/-+/g, '-');

  return str;
}



// WEBPACK FOOTER //
// local_static/templates/volei/2018/assets/scripts/helpers/formatters/slugify.js